import React, { useEffect, useState, useReducer, useCallback } from "react";
import { useHistory, Link } from "react-router-dom";
import { Table, Button } from "react-bootstrap";
import { FaExclamationCircle } from "react-icons/fa";
import {
  getUsuarioById,
  updateUsuario,
  DeleteUsuario,
  EstadoUsuario,
  resetPassword,
  getUserCredentials,
} from "../../api/usuarioApi";
import { FaEye } from "react-icons/fa";
import { getAllLegajoByOneUsuario, getLegajoByData } from "../../api/marcacionApi";
import ModalPreviewUsuario from "../components/sis/ModalUsuario/ModalPreviewUsuario.js";
import { Dropdown } from "rsuite";
import PageIcon from "@rsuite/icons/Page";
import MenuIcon from "@rsuite/icons/Menu";
import TagLockIcon from "@rsuite/icons/TagLock";
import EditIcon from "@rsuite/icons/Edit";
import MinusRoundIcon from "@rsuite/icons/MinusRound";
import CloseOutlineIcon from "@rsuite/icons/CloseOutline";
import "rsuite/dist/rsuite-no-reset.min.css";
import EditUser from "../components/sis/ModalUsuario/EditUser";
import Modalpass from "../components/sis/ModalUsuario/ModalPass.js";
import { getPacienteByProfesional, getAllPaciente } from "../../api/pacienteApi";
import { exportToExcel } from "react-json-to-excel";
import ModalDescargaSesiones from "../components/sis/modalreportes/ModalDescargaSesiones";
import Swal from "sweetalert2";
import { getAdminById } from "../../api/AdminApi";
import { useParams } from "react-router-dom";
const showReducer = (curShow, state) => {
  switch (state.type) {
    case "SHOW":
      return { isShow: true };
    case "SHOW2":
      return { isShow2: true, typeModal: state.typeModal };
    case "SHOW3":
      return { isShow3: true, typeModal: state.typeModal };
    case "4":
      return {
        isShowDescargaMarcaciones: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
      };
    case "END":
      return {
        ...curShow,
        isShow: false,
        isShow2: false,
        isShow3: false,
        isShowDescargaMarcaciones: false,
      };
    default:
      return curShow;
  }
};

const FichaUser = () => {
  const history = useHistory();

  const { id } = useParams(); // viene de la URL /Fichaclientes/:id

  // Helper para mostrar "Sin Datos"
  const showOr = useCallback((v) => {
    if (v === null || v === undefined) return "Sin Datos";
    if (typeof v === "string") return v.trim() === "" ? "Sin Datos" : v;
    return v;
  }, []);

  // Permiso y loading
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);

  // Estados
  const [reducer, dispatchReducer] = useReducer(showReducer, {
    isShow: false,
    isShow2: false,
    isShow3: false,
    isShowDescargaMarcaciones: false,
  });
  const [items, setItems] = useState([]);
  const [List, setList] = useState();
  const [Cliente] = useState("Usuario del Servicio");
  const [edad, setEdad] = useState();
  const [MesCumple, setMesCumple] = useState();
  const [isColored, setIsColored] = useState(false);
  const [Estado, setEstado] = useState();
  const [preview, setPreview] = useState();
  const [activar, setactivar] = useState();
  const [TipoCuenta, setTipoCuenta] = useState();
  const [listMarcacion, setListMarcacion] = useState([]);
  const [listProfesional, setListProfesional] = useState([]);

  // -- Permisos para cuentas --
  useEffect(() => {
    const checkPermissionAndLoad = async () => {
      setLoading(true);
      try {
        const resultUser = await getUserCredentials();
        const USERDATA = await getAdminById(resultUser.IdUsuario);
        if (USERDATA.cuentas === "true") {
          setHasPermission(false);
          return;
        }
        setHasPermission(true);
      } catch {
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };
    checkPermissionAndLoad();
  }, []);

  // -- Carga de datos --
  const assigmentValue = useCallback(async () => {
    try {
      setLoading(true);
      const [listResult, resultProfesional, result] = await Promise.all([
        getAllLegajoByOneUsuario(id),
        getPacienteByProfesional(id),
        getUsuarioById(id),
      ]);
      setListMarcacion(listResult || []);
      setListProfesional(resultProfesional || []);
      setItems(result || []);

      // Imagen
      try {
        const imgPath = result?.[0]?.imagen;
        if (imgPath) {
          const res = await fetch(`https://eethsa.xyz/eethsa1/${imgPath}`);
          if (!res.ok) throw new Error("No se pudo cargar la imagen");
          const imageBlob = await res.blob();
          const imageObjectURL = URL.createObjectURL(imageBlob);
          setPreview(imageObjectURL);
        } else {
          setPreview(undefined);
        }
      } catch {
        setPreview(undefined);
      }

      // Edad / estado
      const hoy = new Date();
      const fechaNac = result?.[0]?.Fechadenacimiento
        ? new Date(result[0].Fechadenacimiento)
        : null;

      if (fechaNac) {
        fechaNac.setMinutes(fechaNac.getMinutes() + fechaNac.getTimezoneOffset());
        const currMonth = new Date(fechaNac).toLocaleString([], { month: "long" });
        let edadnow = hoy.getFullYear() - fechaNac.getFullYear();
        const m = hoy.getMonth() - fechaNac.getMonth();
        if (m < 0 || (m === 0 && hoy.getDate() < fechaNac.getDate())) {
          edadnow--;
        }
        setEdad(edadnow);
        setMesCumple(currMonth);
      } else {
        setEdad("");
        setMesCumple("");
      }

      if (result?.[0]?.estaActivo === "Activo") {
        setEstado("Activo");
        setIsColored(true);
        setactivar("Inhabilitar");
      } else {
        setEstado("Inactivo");
        setIsColored(false);
        setactivar("Habilitar");
      }

      if (result?.[0]?.IdTipoUsuario == 2) setTipoCuenta("Enfermeria");
      if (result?.[0]?.IdTipoUsuario == 3) setTipoCuenta("Logistica");
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    if (hasPermission === true && id) {
      assigmentValue();
    }
  }, [hasPermission, id, assigmentValue]);

  // -- Modales y acciones --
  const handleShow3 = () => {
    dispatchReducer({ type: "SHOW2", typeModal: "USUARIO" });
  };
  const handleShow = () => {
    dispatchReducer({ type: "SHOW" });
  };
  const handleShow2 = () => {
    dispatchReducer({ type: "SHOW3" });
  };
  const onCloseModal = () => {
    dispatchReducer({ type: "END" });
  };
  const HandleMarcaciones = async () => {
    const resultUsuario = await getAllPaciente();
    const resultMapeado = (resultUsuario || []).map((item) => {
      return { label: item.NombrePaciente, value: item.IdPacientes };
    });
    const newList = [{ label: "TODOS", value: "TODOS" }, ...resultMapeado];
    setList(newList);
    dispatchReducer({ type: "4" });
  };
  const GenerarReporte = async (data) => {
    dispatchReducer({ type: "END" });
    try {
      const listResult = await getLegajoByData({
        ...data,
        idPaciente: data.ID,
        idUsuario: id,
      });
      exportToExcel(listResult, "Reporte De Marcacion");
    } catch (err) {
      console.log(err);
    }
  };

  const Eliminar = () => {
    Swal.fire({
      title: "Eliminar Cuenta",
      text: `Estas seguro que desea eliminar la Cuenta ${items?.[0]?.Nombre}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Si, Eliminar",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          "Eliminado",
          "Cuenta Eliminado.",
          "success",
          history.push("/usuarios"),
          DeleteUsuario(items?.[0]?.IdUsuario)
        );
      }
    });
  };

  const EstadousuarioCambiar = async () => {
    const IdUsuario = items?.[0]?.IdUsuario;
    if (!IdUsuario) return;
    await Swal.fire({
      input: "textarea",
      inputLabel: "Motivo",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const motivo = result.value;
        Swal.fire(
          "Cambiado",
          "Estado Actualizado.",
          "success",
          EstadoUsuario({ IdUsuario, motivo }),
          assigmentValue()
        );
      }
    });
  };

  const onReturnUsuarioData = async (data) => {
    try {
      Swal.fire({
        title: "Cargando",
        html: "Cargando  datos",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
      });
      const result = await updateUsuario({
        ...data,
        IdUsuario: items?.[0]?.IdUsuario,
      });
      if (result) {
        Swal.close();
        Swal.fire({
          title: "Usuario",
          html: `Se guardo correctamente el usuario`,
          icon: "success",
        });
        assigmentValue();
        dispatchReducer({ type: "END" });
      }
    } catch (err) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${err}`,
      });
    }
  };

  const onReturnPass = async (data) => {
    dispatchReducer({ type: "END" });
    try {
      Swal.fire({
        title: "Actualizando",
        html: "Actualizando  datos",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
      });
      const result = await resetPassword({
        ...data,
        IdUsuario: items?.[0]?.IdUsuario,
      });
      if (result) {
        Swal.close();
        Swal.fire({
          title: "Usuario",
          html: `Se Actualizo Correctamente`,
          icon: "success",
        });
      }
    } catch (err) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${err}`,
      });
    }
  };

  // Divider reutilizable
  const Divider = ({ space = 24 }) => (
    <div style={{ borderTop: "1px solid #e9ecef", margin: `${space}px 0` }} />
  );

  // Estilo del recuadro de la izquierda
  const accountBoxStyle = {
    border: "1px solid #e9ecef",
    borderRadius: 12,
    padding: 16,
    background: "#fff",
    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
  };

  // -- Loading / permisos --
  if (loading) {
    return (
      <div
        style={{
          minHeight: "60vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          zIndex: 2,
        }}
      >
        <div
          style={{
            width: 38,
            height: 38,
            border: "4px solid #ddd",
            borderTop: "4px solid #1569c9ff",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>Cargando...</span>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg);}
              100% { transform: rotate(360deg);}
            }
          `}
        </style>
      </div>
    );
  }
  if (hasPermission === false) {
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        <h3>No tiene permisos para ver esta información.</h3>
      </div>
    );
  }
  if (hasPermission !== true) {
    return null;
  }

  // Render
  return (
    <>
      {items.map((item) => {
        return (
          <div key={item.IdUsuario}>
            <div className="col-xl-12">
              {/* Card unificado con layout: Izquierda recuadro centrado (foto + datos de cuenta) / Derecha datos personales y contacto */}
              <div className="card profile-card card-bx m-b30">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0">Cuenta</h4>
                  <div className="d-flex align-items-center">
                    <Dropdown icon={<MenuIcon />} noCaret placement="leftStart">
                      <Dropdown.Item icon={<PageIcon />} onClick={handleShow}>
                        Descargar Ficha
                      </Dropdown.Item>
                      <Dropdown.Item icon={<TagLockIcon />} onClick={handleShow2}>
                        Cambiar Contraseña
                      </Dropdown.Item>
                      <Dropdown.Item icon={<EditIcon />} onClick={handleShow3}>
                        Editar
                      </Dropdown.Item>
                      <Dropdown.Item icon={<MinusRoundIcon />} onClick={EstadousuarioCambiar}>
                        {activar}
                      </Dropdown.Item>
                      <Dropdown.Item icon={<CloseOutlineIcon />} onClick={Eliminar}>
                        Eliminar
                      </Dropdown.Item>
                    </Dropdown>
                  </div>
                </div>

                {/* Modales */}
                {reducer.isShow && (
                  <ModalPreviewUsuario
                    estado={reducer.isShow}
                    onCloseModal={onCloseModal}
                    datos={item}
                    edad={edad}
                    mescumple={MesCumple}
                    cargo={TipoCuenta}
                    preview={preview}
                  />
                )}
                {reducer.isShow2 && (
                  <EditUser
                    estado={reducer.isShow2}
                    datos={items}
                    typeModal={reducer.typeModal}
                    onCloseModal={onCloseModal}
                    onReturnValue={onReturnUsuarioData}
                    img={preview}
                  />
                )}
                {reducer.isShow3 && (
                  <Modalpass estado={reducer.isShow3} onCloseModal={onCloseModal} onReturnValue={onReturnPass} />
                )}

                <div className="card-body">
                  <div className="row">
                    {/* Izquierda: recuadro centrado con foto arriba, luego nombre/profesión/estado, luego datos de cuenta */}
                    <div className="col-lg-4">
                      <div className="d-flex flex-column align-items-center text-center" style={accountBoxStyle}>
                        <div
                          className="author-media"
                          style={{
                            width: 120,
                            height: 120,
                            overflow: "hidden",
                            borderRadius: "50%",
                            marginBottom: 12,
                          }}
                        >
                          {preview ? (
                            <img
                              src={preview}
                              alt="Foto de usuario"
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                background: "#f0f0f0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#888",
                                fontSize: 12,
                              }}
                            >
                              Sin Imagen
                            </div>
                          )}
                        </div>

                        <h6 className="title mb-1">{showOr(item.Nombre)}</h6>
                        <span className="d-block">{showOr(TipoCuenta)}</span>
                        <strong
                          className="d-block mt-1"
                          style={{ color: isColored ? "green" : "red" }}
                        >
                          {showOr(Estado)}
                        </strong>

                        {Estado !== "Activo" && (
                          <div className="mt-2" style={{ maxWidth: 320 }}>
                            <span className="text-muted d-block small">Motivo Inactivo</span>
                            <div className="fw-semibold">{showOr(item.motivo)}</div>
                          </div>
                        )}

                        <Divider space={16} />

                        <h6 className="title mb-3">Datos de Cuenta</h6>
                        <ul className="list-unstyled mb-0" style={{ width: "100%", maxWidth: 360 }}>
                          <li className="mb-2">
                            <span className="text-muted d-block small">Usuario</span>
                            <strong>{showOr(item.Usuario)}</strong>
                          </li>
                          <li className="mb-2">
                            <span className="text-muted d-block small">Profesión</span>
                            <strong>{showOr(item.subtipo)}</strong>
                          </li>
                          <li className="mb-2">
                            <span className="text-muted d-block small">Registro Profesional</span>
                            <strong>{showOr(item.RegistroProfesional)}</strong>
                          </li>
                          <li className="mb-2">
                            <span className="text-muted d-block small">Fecha de Ingreso</span>
                            <strong>{showOr(item.Fechaingreso)}</strong>
                          </li>
                          <li className="mb-1">
                            <span className="text-muted d-block small">Método de Pago</span>
                            <strong>{showOr(item.metododepago)}</strong>
                          </li>
                        </ul>
                      </div>
                    </div>

                    {/* Derecha: Datos Personales + Contacto */}
                    <div className="col-lg-8">
                      <h6 className="title mb-3">Datos Personales</h6>
                      <div className="row">
                        <div className="col-sm-4 m-b30">
                          <label className="form-label">Cédula de Identidad</label>
                          <span className="form-control">{showOr(item.Cedula)}</span>
                          <label className="form-label mt-3">Fecha de Nacimiento</label>
                          <span className="form-control">{showOr(item.Fechadenacimiento)}</span>
                          <label className="form-label mt-3">Edad</label>
                          <span className="form-control">{showOr(edad)}</span>
                        </div>
                        <div className="col-sm-4 m-b30">
                          <label className="form-label">Sexo</label>
                          <span className="form-control">{showOr(item.sexo)}</span>
                          <label className="form-label mt-3">Estado Civil</label>
                          <span className="form-control">{showOr(item.estadocivil)}</span>
                          <label className="form-label mt-3">Hijos</label>
                          <span className="form-control">{showOr(item.hijos)}</span>
                        </div>
                        <div className="col-sm-4 m-b30">
                          <label className="form-label">Mes de Cumpleaños</label>
                          <span className="form-control">{showOr(MesCumple)}</span>
                          <label className="form-label mt-3">Antecedentes Policiales</label>
                          <span className="form-control">{showOr(item.antpol)}</span>
                        </div>
                      </div>

                      <Divider space={16} />

                      <h6 className="title mb-3">Contacto</h6>
                      <div className="row">
                        <div className="col-sm-4 m-b30">
                          <label className="form-label">Teléfono</label>
                          <span className="form-control">{showOr(item.Telefono)}</span>
                        </div>
                        <div className="col-sm-4 m-b30">
                          <label className="form-label">Departamento</label>
                          <span className="form-control">{showOr(item.departamento)}</span>
                          <label className="form-label mt-3">Ciudad</label>
                          <span className="form-control">{showOr(item.Ciudad)}</span>
                        </div>
                        <div className="col-sm-4 m-b30">
                          <label className="form-label">Barrio</label>
                          <span className="form-control">{showOr(item.barrio)}</span>
                          <label className="form-label mt-3">Dirección</label>
                          <span className="form-control">{showOr(item.direccion)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pacientes Asignados */}
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Pacientes Asignados</h4>
                </div>
                <div className="card-body p-6">
                  <Table responsive className="primary-table-bordered col-6 ">
                    <thead className="thead-primary">
                      <tr>
                        <th scope="col">Paciente</th>
                        <th scope="col">Guardia HS</th>
                        <th scope="col">Honorario</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listProfesional.map((p, index) => (
                        <tr key={index}>
                          <td>{showOr(p.NombrePaciente)}</td>

                          <td>{showOr(p.guardiahs)}</td>
                          <td>{showOr(p.honorarioenfermero)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>

              {/* Sesiones */}
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0">Sesiones</h4>
                  <Button onClick={HandleMarcaciones}>Descargar Marcaciones</Button>
                  {reducer.isShowDescargaMarcaciones && (
                    <ModalDescargaSesiones
                      estado={reducer.isShowDescargaMarcaciones}
                      onCloseModal={onCloseModal}
                      onReturnValue={GenerarReporte}
                      Lista={List}
                      ClienteOCuenta={Cliente}
                    />
                  )}
                </div>

                <div className="card-body">
                  <div className="table-responsive recentOrderTable">
                    <table className="table verticle-middle table-responsive-md">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Paciente</th>
                          <th scope="col">Cuenta</th>
                          <th scope="col">Fecha Entrada</th>
                          <th scope="col">Hora Entrada</th>
                          <th scope="col">Fecha Salida</th>
                          <th scope="col">Hora Salida</th>
                          <th scope="col">Opc.</th>
                        </tr>
                      </thead>

                      <tbody>
                        {listMarcacion.slice(0, 20).map((m, index2) => (
                          <tr key={index2}>
                            <td>
                              {showOr(m.IdLegajoEnfermeria)}{" "}
                              {m.isHojaEnfermeria === "NO" && (
                                <FaExclamationCircle style={{ color: "red", fontSize: "18px", marginLeft: "5px" }} />
                              )}
                            </td>
                            <td>
                              <Link to={`/Fichaclientes/${m.IdPaciente}`}>
                                {showOr(m.Paciente)}
                              </Link>
                            </td>
                            <td>{showOr(m.Usuario)}</td>
                            <td>{showOr(m.Fecha)}</td>
                            <td>{showOr(m.HoraEntrada)}</td>
                            <td>{showOr(m.FechaSalida)}</td>
                            <td>{showOr(m.HoraSalida)}</td>
                            <td>
                              <Link to={`/legajo/${m.IdLegajoEnfermeria}`}>
                                <i className="material-icons" style={{ height: "100" }}>
                                  <FaEye />
                                </i>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Fin Sesiones */}
            </div>
          </div>
        );
      })}
    </>
  );
};
export default FichaUser;